export default (stateName) => {
	return {
		initiated: false,
		initiating: false,
		[stateName]: [],
		editorUserList: []
	};
};
